import { GetApi, PostApi, PutApi, DeleteApi } from './api';

export const getGameAchievements = (params, isHeader = true) => {
  let query = '';
  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    query = `?${queryParams}`;
  }
  return GetApi(`admin/v1/game-achievements${query}`, isHeader).then((response) => {
    return response.data;
  });
};

export const createGameAchievement = (payload, isHeader = true) => {
  return PostApi('admin/v1/game-achievements', payload, isHeader).then((response) => {
    return response.data;
  });
};

export const updateGameAchievement = (id, payload, isHeader = true) => {
  return PutApi(`admin/v1/game-achievements/${id}`, payload, isHeader).then((response) => {
    return response.data;
  });
};

export const deleteGameAchievement = (id, isHeader = true) => {
  return DeleteApi(`admin/v1/game-achievements/${id}`, isHeader).then((response) => {
    return response.data;
  });
};

export const getAchievementTypes = (isHeader = true) => {
  return GetApi('admin/v1/game-achievements/types', isHeader).then((response) => {
    return response.data;
  });
};
